"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentFile = exports.timeRemainingFormat = void 0;
var Types = require("types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var timeRemainingFormat = function (remaining) {
    var reminder = remaining % 3600;
    var hours = Math.floor(remaining / 3600);
    var minutes = Math.floor(reminder / 60);
    var seconds = Math.ceil(reminder % 60);
    var s = seconds > 0 ? "".concat(seconds, "s") : '';
    var m = minutes > 0 ? "".concat(minutes, "m ") : '';
    var h = hours > 0 ? "".concat(hours, "h ") : '';
    return (h + m + s).trim();
};
exports.timeRemainingFormat = timeRemainingFormat;
var currentFile = function (files, uploadedFiles) {
    var uploading = Object.entries(uploadedFiles).filter(function (_a) {
        var v = _a[1];
        return v.status !== Types.UPLOADED && v.status !== Types.FAILED;
    });
    if (uploading.length === 1) {
        var currentItem = files.filter(function (f) { return f.uuid === uploading[0][0]; });
        if (currentItem.length > 0) {
            return " ".concat(currentItem[0].name, " ");
        }
        else {
            return " ".concat((0, translation_1.getLocalization)('uploadstatusbar/files/Unknown'), " ");
        }
    }
    if (uploading.length > 1) {
        return " ".concat((0, translation_1.getLocalization)('uploadstatusbar/files/uploaded'), " ").concat(uploading.length, "/").concat(files.length, " ");
    }
    return " ".concat((0, translation_1.getLocalization)('uploadstatusbar/files/allFilesUploaded'), " ");
};
exports.currentFile = currentFile;
